<template>
  <div>
    <div class="retouch">
      <RetouchForm :album="album" ref="form" @start="start"/>
      <template v-if="doing">
        <div>下载：{{ download.done }} / {{ download.total }}</div>
        <div style="margin-bottom:10px;">回传：{{ upload.done }} / {{ upload.total }}</div>
      </template>
      <a-button v-if="!doing" shape="round" icon="play-circle" @click="config">开启修图</a-button>
      <a-popconfirm v-else title="停止修图将中断所有上传和下载任务，你确定要停止吗？"
                    ok-text="确认" cancel-text="取消" @confirm="finish" placement="leftBottom">
        <a-button shape="round" icon="pause-circle">停止修图</a-button>
      </a-popconfirm>
      <UseElectron ref="useElectron"/>
    </div>
    <div class="retouch2" v-if="retouch2">
      <a-button v-if="!doing" shape="round" icon="play-circle" @click="config">开启修图</a-button>
      <a-popconfirm v-else title="停止修图将中断所有上传和下载任务，你确定要停止吗？"
                    ok-text="确认" cancel-text="取消" @confirm="finish" placement="leftTop">
        <a-button shape="round" icon="pause-circle">停止修图</a-button>
      </a-popconfirm>
    </div>
  </div>
</template>

<script>
import api from "../../../../../utils/api";
import RetouchForm from "./RetouchForm";
import func from "../../../../../utils/func";
import enums from "../../../../../utils/enums";
import dload from "../../../../../utils/dload";
import UseElectron from "@/comps/UseElectron";

export default {
  name: "RetouchButton",
  components: {UseElectron, RetouchForm},
  props: {
    album: Object,
    member: Object,
  },
  data() {
    return {
      doing: false,
      download: {
        done: 0,
        total: 0
      },
      upload: {
        done: 0,
        total: 0,
        watcher: null,
      },
      electron: window.IS_ELECTRON,
    }
  },
  computed: {
    retouch2() {
      return this.$store.getters["layout/contentWidth"] > 1200;
    }
  },
  methods: {
    config() {
      this.electron ? this.$refs.form.open() : this.$refs.useElectron.open(true);
    },
    async start(args) {
      this.doing = true;
      this.download = {done: 0, total: 0};
      this.upload = {done: 0, total: 0, watcher: null};
      this.upload.watcher = await window.readyUpload(
          this.album.id, this.member.id, args.exportDir,
          () => this.upload.total += 1,
          () => this.upload.done += 1);
      await this.handle(args, 1, 0);
    },
    finish() {
      this.doing = false;
      this.upload.watcher.close();
    },
    async handle(args, page, prevCount) {
      if (!this.doing) return;
      const self = this;
      let res = await api.v1.album.photo
          .retouchSearch(this.album.id, {
            member_id: args.grapherId,
            retouch: 4, // 未完成+已完成
            page_no: page,
            page_size: 20,
          });
      if (res.data.length === prevCount) {
        return func.setTimeout(5000, () => self.handle(args, page, prevCount));
      }
      let files = [];
      let photos = [];
      res.data.forEach(item => photos.push(item.id));
      let urls = await api.v1.album.photo.URL(this.album.id, photos);
      res.data.forEach(item => {
        if (!func.isDefined(urls[item.id])) return;
        if (item.raw.id !== "") {
          let name = `${enums.Upload.TypeRaw}#${item["info"]["catch_time"]}#${item["info"]["file_name"]}`;
          files.push({url: urls[item.id], name: name});
        }
        if (item["foto"]["id"] !== "") {
          let type = item.origin ? enums.Upload.TypeOrigin : enums.Upload.TypeHD;
          let name = `${type}#${item["info"]["catch_time"]}#${item["info"]["file_name"]}`;
          files.push({url: urls[item.id], name: name});
        }
        if (item.raw.id && item["foto"]["id"]) this.download.total += 1;
      });
      this.download.total = res.total;
      this.download.done -= prevCount;
      await dload.electron.download2(args.downloadDir, files, (done, total, num) => {
        self.download.done += num;
        if (done === total) {
          if (res.data.length < 20) {
            func.setTimeout(5000, () => {
              self.handle(args, page, res.data.length);
            });
          } else {
            self.handle(args, page + 1, 0);
          }
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
.retouch {
  right: 32px;
  bottom: 20px;
  padding: 10px;
  z-index: 1000;
  position: fixed;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  border-radius: 20px;
  background: #ff5500;
  border: 5px #fff solid;
  box-shadow: 0 0 10px 2px #222;
}

.retouch2 {
  top: 72px;
  right: 15px;
  position: fixed;
  z-index: 1000;

  .ant-btn {
    color: #ffffff;
    background: #ff5500;
    border-color: #ff5500;
  }
}
</style>